import React, {useContext, useEffect, useState} from 'react';
import TourListItem from "../components/Tour-list-item/Tour-list-item";
import {axios} from "../axios";
import {LangContext} from "../App";
import Seo from "../components/Seo/Seo";

const GroupToursPage = () => {
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/group-tour`)
            .then( res => setData(res.data.tours))
    },[lang])
    return (
        <div className='tours'>
            <Seo pageKey="groupTours" />
            <div className="center-wrapper">
                <div className="tours-grid">
                    {data?.map(e => <TourListItem tour={e} path='group-tour'/>)}
                </div>
            </div>
        </div>
    );
};

export default GroupToursPage;